function Platforms() {

  return (

    <section id="platforms" className="reveal">

      <div className="section-title">
        <h2>Platforms</h2>
      </div>

      <div className="platform-grid">

        <a
          href="https://github.com/Banka-Lakshmi-Chaitanya-Ram"
          target="_blank"
          rel="noopener noreferrer"
          className="card"
        >
          <h3>GitHub</h3>
          <p>Banka-Lakshmi-Chaitanya-Ram</p>
        </a>

        <a
          href="https://www.linkedin.com/in/banka-lakshmi-chaitanya-ram-5bab24385/"
          target="_blank"
          rel="noopener noreferrer"
          className="card"
        >
          <h3>LinkedIn</h3>
          <p>Banka Lakshmi Chaitanya Ram</p>
        </a>

        <a
          href="https://sketchfab.com/Chaitanyaram._.7"
          target="_blank"
          rel="noopener noreferrer"
          className="card"
        >
          <h3>Sketchfab</h3>
          <p>@Chaitanyaram._.7</p>
        </a>

        <a
          href="https://www.instagram.com/why._.not_.everything/"
          target="_blank"
          rel="noopener noreferrer"
          className="card"
        >
          <h3>Instagram</h3>
          <p>@why._.not_.everything</p>
        </a>

        <a
          href="https://x.com/YnotEverything"
          target="_blank"
          rel="noopener noreferrer"
          className="card"
        >
          <h3>X</h3>
          <p>@YnotEverything</p>
        </a>

        <div className="card">
          <h3>Behance</h3>
          <p>Coming Soon</p>
        </div>

        <div className="card">
          <h3>ArtStation</h3>
          <p>Coming Soon</p>
        </div>

      </div>

    </section>

  );

}

export default Platforms;